import { configureStore } from '@reduxjs/toolkit';

import { apiSlice } from '../api/apiSlice';
import authReducer from '../components/core/auth/authSlice';
import snackReducer from '../components/shared/AktivuSnackbar/snackSlice';
/**
 * RTK Store
 */
export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authReducer,
    snack: snackReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(apiSlice.middleware),
  devTools: true,
});
